import React from "react";
import { Modal, Input, Table, Popover, Button, DatePicker, Select} from "antd";

const {RangePicker} = DatePicker;
const Search = Input.Search;
const Option = Select.Option
const content = (
    <div className="action-column action-dropdown">
      <a title="View"><i className="fa fa-eye" /></a>
      <a title="Edit"><i className="fa fa-pencil" /></a>
      <a title="Print"><i className="icon-printer" /></a>
    </div>
);

export class InvoicePayment extends React.Component {
  state={
    AddWasteProfile:false,
  }
  showAddWasteProfile=(visible)=>{
    this.setState({AddWasteProfile:visible})
  }
   setAddUpdateHotSheetModel(addUpdateHotSheetModel) {
    this.setState({addUpdateHotSheetModel});
  }

columns = [
  {
    title: 'Action',
    render: item =>
     <Popover placement="right" content={content} trigger="hover">
        <a className="action-dropdown" href="#"><i className="fa fa-ellipsis-h"/> </a>
      </Popover>
  },{
    title: 'Work Order#',
  dataIndex: 'workorder_number',
  key: 'workorder_number',
}, {
  title: 'Created Date',
  dataIndex: 'created',
  key: 'created',
}, {
  title: 'Invoice#',
  dataIndex: 'invoice',
  key: 'invoice',
},{
  title: 'Generator',
  dataIndex: 'generator',
  key: 'generator',
},{
  title: 'Bill To',
  dataIndex: 'bill_to',
  key: 'bill_to',
},
];

 data = [{
   key: '1',
   workorder_number: '214523',
   created: '214523',
   invoice: '214523',
   generator: <span>XYZ <br />ID: <div className="id-gen">12854</div></span>,
   bill_to: <span>May Tank <br />ID: <div className="id-gen">N816</div></span>,
},{
   key: '2',
   workorder_number: '214523',
   created: '214523',
   invoice: '214523',
   generator: <span>XYZ <br />ID: <div className="id-gen">12854</div></span>,
   bill_to: <span>May Tank <br />ID: <div className="id-gen">N816</div></span>,
},{
   key: '3',
   workorder_number: '214523',
   created: '214523',
   invoice: '214523',
   generator: <span>XYZ <br />ID: <div className="id-gen">12854</div></span>,
   bill_to: <span>May Tank <br />ID: <div className="id-gen">N816</div></span>,
},{
   key: '4',
   workorder_number: '214523',
   created: '214523',
   invoice: '214523',
   generator: <span>XYZ <br />ID: <div className="id-gen">12854</div></span>,
   bill_to: <span>May Tank <br />ID: <div className="id-gen">N816</div></span>,
},{
   key: '5',
   workorder_number: '214523',
   created: '214523',
   invoice: '214523',
   generator: <span>XYZ <br />ID: <div className="id-gen">12854</div></span>,
   bill_to: <span>May Tank <br />ID: <div className="id-gen">N816</div></span>,
},];

  render() {
    const { visible } = this.props;

    return (
      <div>
            <div className="row clearfix ">
              <div className="col-sm-3 col-10">
                 <Select className="border-select" defaultValue="All" style={{ width: "100%" }}>
                  <Option value="all">All</Option>
                  <Option value="work1">WO231456</Option>
                  <Option value="work2">WO231457</Option>
                  <Option value="work3">WO231458</Option>
                </Select>
              </div>
              <div className="col-sm-4 col-10">
                <Search placeholder="Input search text" style={{ width: "100%" }} />
              </div>
               <div className="col-sm-5 col-12">
                  <RangePicker width={"100%"} />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="listing-table">
                  <Table className="responsive-table table table-hover waste-profile-tbl" columns={this.columns} dataSource={this.data} />
                </div>
              </div>
            </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/account/account_components/InvoicePayment.jsx